import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import Table from '../../../../../components/common/table/table';
import Work from '../../../../../interfaces/work';
import { CROP_FIELD_VIEW, CROP_WORK_VIEW } from '../../../../../router/routes';
import { useService } from '../../../../../services/services';
import { route } from '../../../../../services/utils';
import { useBackButton } from '../../backButtonContext';
import tabKeys from '../../../../../enums/tab-keys';

export default function View() {
  const { farmId, season, id } = useParams<{
    farmId: string;
    season: string;
    id: string;
  }>();
  const translationKeyPrefix = 'pages.crop.works.';
  const { t } = useTranslation();
  const tp = useCallback((key: string) => t(translationKeyPrefix + key), [t]);
  const { workService } = useService();
  const { setBackButton } = useBackButton();

  useEffect(() => {
    setBackButton(
      route(CROP_FIELD_VIEW, {
        farmId,
        season,
        id,
        tab: tabKeys.works,
      })
    );
  }, [farmId, id, season, setBackButton]);

  const request = useCallback(
    (page: number, sort: string, desc: boolean, filter: any) =>
      workService.index(farmId, season, {
        page,
        sort,
        desc,
        field_lad_number: id,
        ...filter,
      }),
    [workService, farmId, season, id]
  );

  return (
    <div>
      <Table<Work>
        request={request}
        keyAccessor="id"
        columns={[
          { accessor: 'done', header: tp('done') },
          {
            accessor: 'date',
            header: tp('date'),
            sortable: true,
            valuable: (value, work: Work) =>
              work.planned ? tp('planned') : value,
          },
          { accessor: 'work.value', header: tp('work'), sortable: true },
          { accessor: 'name', header: tp('name') },
        ]}
        viewRoute={route(CROP_WORK_VIEW, { farmId: farmId, season: season })}
        viewRecordAbility={{ entity_type: 'work' }}
      />
    </div>
  );
}
